import { createBrowserRouter } from 'react-router-dom';
import { Home } from '../controllers/home/home';
import { InstallationGuide } from '../controllers/istallationGuide';
import { About } from '../controllers/about';
import { Layout } from '../composites/layout';

export const router = createBrowserRouter([
  {
    element: <Layout />,
    errorElement: <div>Page not found</div>,
    children: [
      {
        path: '/home',
        element: <Home />,
      },
      {
        path: '/installation',
        element: <InstallationGuide />,
      },
      {
        path: '/about',
        element: <About />,
      },
      {
        path: '/',
        element: <Home />,
        errorElement: <div>Page not found</div>,
      },
    ],
  },
]);
